<!-- smallChange [ 零钱明细 ] -->
<template>

    <div id='smallChange'>
        
        <div class="meter_search" style="height: 58px;margin-top: 20px;margin-bottom: 30px;">
			<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="search">

				<el-form-item label="第三方订单号">
					<el-input v-model="select.numbers" style="width:200px;" :maxlength="12"></el-input>
				</el-form-item>

                <el-form-item label="充值时间">
                    <el-date-picker v-model="select.start" type="date" placeholder="选择开始日期">
                    </el-date-picker>
                    <el-date-picker v-model="select.end" type="date" placeholder="选择结束日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="支付方式">
                    <el-select v-model="select.type" placeholder="请选择" style="width: 110px;">
                        <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
		   			<el-button type="primary" @click="resetting">重置</el-button>
				</el-form-item>

			</el-form>
		</div>  

        <div>
            <el-table :data="dataset" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;margin-top: 10px;">
                <el-table-column prop="account" label="户号" align="center">
                </el-table-column>
                <!-- <el-table-column prop="meter_code" label="表号" align="center">
                </el-table-column> -->
                <el-table-column prop="order_code" label="第三方订单号" align="center">
                </el-table-column>
                <el-table-column prop="money" label="零钱"  align="center">
                    <template scope="scope">
                        <span style="color: red;" v-if="scope.row.type == 1">-{{scope.row.money}}</span>
                        <span style="color: green;" v-else>+{{scope.row.money}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="diff_money" label="补交阶梯差价金额"  align="center">
                    <template scope="scope">
                        <span v-if="scope.row.type == 1">--</span>
                        <span v-else>{{scope.row.diff_money}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="total" label="支付金额（元）"  align="center">
                </el-table-column>
                <el-table-column prop="time" label="支付时间"  align="center">
                </el-table-column>
                <el-table-column prop="pay_type" label="支付类型" align="center">
                    <template scope="scope">
                        {{(scope.row.pay_type == 1 ? '支付宝' : scope.row.pay_type == 2 ? '微信' : scope.row.pay_type == 3 ? '银联' : scope.row.pay_type == 4 ? '现金' : scope.row.pay_type == 5 ? '支票' : scope.row.pay_type == 6 ? '光大银行' : scope.row.pay_type == 7 ? '直充' : '')}}
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
            </el-pagination>
        </div>

    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            codeKey: null,

            select:{
                numbers: '',
                start: '',
                end: '',
                type: '',
            },

            types: [],

            dataset: [],
            pageSize: 15,
            total: null,
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){
            this.codeKey = this.$route.params.orderid;

            // 支付方式
            this.$jssdk.order.getPaytype({metercode: this.$route.params.orderid},(data) =>{
                this.types = data;
            });
        },

        getData(){
            // getdata
            this.$jssdk.ystair.pocketList({
                code: this.$route.params.orderid || '',
                thirdordernum: this.select.numbers || '',
                pay_type: this.select.type || '',
                start_time: Math.round(this.select.start / 1000) || '',
                end_time: Math.round(this.select.end / 1000) || '',
            }, (res) => {
                this.dataset = res.list;
                this.total = Number(res.count);
            }, (err) => {
                this.$message(error.msg);
            });
        },

        // 查询
        search(){
            this.getData();
        },

        // 重置
        resetting(){
            this.select.numbers = '';
            this.select.start = '';
            this.select.end = '';
            this.select.type = '';
        },

        // page
        handleSizeChange(val) {},

        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },

        sortChange(){

        },
    },
}
</script>


// WEBPACK FOOTER //
// smallChange.vue?55c45060